module.exports = __webpack_public_path__ + "static/img/img1.35b37a8d.png";